import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { stringSorter } from "../../utils/functions.js";
import DataTable from "../../components/CustomDatatable/index.js";
import {
  Button,
  Card,
  Space,
  Typography,
  Breadcrumb,
  Row,
  Col,
  Switch,
  message,
  Modal,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  HomeOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Spinner } from "reactstrap";
import BankForm from "./BankForm.js";
import { enhanceColumnsWithFilters } from "../../components/ColumnFilters/index.js";
import moment from "moment-timezone";
import { deletePackage } from "../../store/actions/package.js";
import {
  addBank,
  deleteBank,
  getBank,
  updateBank,
  updateBankStatus,
} from "../../store/actions/bank.js";

const { Title } = Typography;

const Bank = () => {
  document.title = "Bank";
  const [isLoading, setIsLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteComfirmModalVisible, setDeleteComfirmModalVisible] =
    useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const dispatch = useDispatch();
  const Bank = useSelector((state) => state.Bank.list);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        await dispatch(getBank());
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    fetchProducts();
  }, [dispatch]);

  const handleCreate = async (values) => {
    if (selectedRecord) {
      await dispatch(updateBank({ ...selectedRecord, ...values }));
    } else {
      await dispatch(addBank(values));
    }
    await dispatch(getBank());
    setIsModalVisible(false);
  };

  // const handleDelete = async (id) => {
  //   await dispatch(deleteBank(id));
  //   await dispatch(getBank());
  // };

  const handleDelete = async (item) => {
    setItemToDelete(item);
    setDeleteModalVisible(true);
  };
  const handleConfirmDelete = async (item) => {
    setItemToDelete(item);
    setDeleteComfirmModalVisible(true);
  };

  const confirmDelete = async () => {
    try {
      await dispatch(deleteBank(itemToDelete.id));
      await dispatch(getBank());
      setDeleteComfirmModalVisible(false);
    } catch (error) {
      message.error("An error occurred while deleting the item");
    }
  };

  const handleChangeStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === 1 ? 0 : 1; // Toggle status
    await dispatch(updateBankStatus({ id, status: newStatus }));
    await dispatch(getBank());
  };

  const renderCell = (text) => (text ? text : "N/A");
  let columns = [
    {
      title: "Logo",
      dataIndex: "logo",
      key: "logo",
      sorter: stringSorter("logo"),
      sortDirections: ["ascend", "descend"],
      render: (logo) => (
        <img
          src={logo}
          alt="Logo"
          style={{ maxWidth: "100px", maxHeight: "100px" }}
           crossOrigin="anonymous"
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: stringSorter("name"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) =>
        moment(date).isValid()
          ? moment(date).format("YYYY-MM-DD HH:mm:ss")
          : "",
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => (
        <Switch
          checked={text === 1}
          onChange={() => handleChangeStatus(record.id, text)}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setSelectedRecord(record);
              setIsModalVisible(true);
            }}
          >
            <EditOutlined />
          </Button>
          {record?.status ? (
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(record)}
            >
              {/* Delete */}
            </Button>
          ) : (
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => handleConfirmDelete(record)}
            >
              {/* Delete */}
            </Button>
          )}
        </Space>
      ),
    },
  ];

  columns = enhanceColumnsWithFilters(columns);

  return (
    <div className="page-content">
      <Breadcrumb style={{ marginBottom: "16px" }}>
        <Breadcrumb.Item href="/">
          <HomeOutlined />
        </Breadcrumb.Item>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Bank</Breadcrumb.Item>
      </Breadcrumb>

      <Card>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Row justify="space-between" align="middle">
            <Col>
              <Title level={2}>Manage Bank</Title>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setSelectedRecord(null);
                  setIsModalVisible(true);
                }}
              >
                Add Bank
              </Button>
            </Col>
          </Row>

          {isLoading ? (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <DataTable
              dataSource={Bank.map((item) => ({
                ...item,
                key: item.id,
                status: item.status ? 1 : 0,
              }))}
              columns={columns}
            />
          )}
        </Space>
      </Card>

      <BankForm
        visible={isModalVisible}
        onCreate={handleCreate}
        onCancel={() => setIsModalVisible(false)}
        record={selectedRecord}
      />
      <Modal
        title="Confirm Delete"
        zIndex={100000000}
        visible={deleteModalVisible}
        onCancel={() => setDeleteModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setDeleteModalVisible(false)}>
            Ok
          </Button>,
          // <Button key="delete" danger onClick={confirmDelete}>
          //   Delete
          // </Button>,
        ]}
      >
        <p>Can not remove active Bank</p>
        {itemToDelete && (
          <p>
            <strong>Bank Name:</strong> {itemToDelete.name}
          </p>
        )}
        {/* <p style={{ color: "red" }}>
          <b>Note: </b> Delete Customer will remove all the data including
          database of customer{" "}
        </p> */}
      </Modal>

      <Modal
        title="Delete Bank"
        zIndex={100000000}
        visible={deleteComfirmModalVisible}
        onCancel={() => setDeleteComfirmModalVisible(false)}
        footer={[
          <Button
            key="cancel"
            onClick={() => setDeleteComfirmModalVisible(false)}
          >
            Cancel
          </Button>,
          <Button key="delete" danger onClick={confirmDelete}>
            Delete
          </Button>,
        ]}
      >
        <p>Are you sure you want to remove bank?</p>
        {itemToDelete && (
          <p>
            <strong>Customer Name:</strong> {itemToDelete.name}
          </p>
        )}
        {/* <p style={{ color: "red" }}>
          <b>Note: </b> Delete Customer will remove all the data including
          database of customer{" "}
        </p> */}
      </Modal>
    </div>
  );
};

export default Bank;

// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { stringSorter } from "../../utils/functions.js";
// import DataTable from "../../components/CustomDatatable/index.js";
// import {
//   Button,
//   Card,
//   Space,
//   Typography,
//   Breadcrumb,
//   Row,
//   Col,
//   Popconfirm,
//   Switch,
//   Form,
// } from "antd";
// import {
//   EditOutlined,
//   HomeOutlined,
//   PlusOutlined,
// } from "@ant-design/icons";
// import { Spinner } from "reactstrap";
// import BankForm from "./BankForm.js";
// import { enhanceColumnsWithFilters } from "../../components/ColumnFilters/index.js";
// import moment from "moment-timezone";
// import { deletePackage } from "../../store/actions/package.js";
// import { addBank, deleteBank, getBank, updateBank } from "../../store/actions/bank.js";

// const { Title } = Typography;

// const Bank = () => {
//   document.title = "Bank";
//   const [isLoading, setIsLoading] = useState(true);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [selectedRecord, setSelectedRecord] = useState(null);
//   // const [form] = Form.useForm();

//   const dispatch = useDispatch();
//   const Bank = useSelector((state) => state.Bank.list);

//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         await dispatch(getBank());
//         setIsLoading(false);
//       } catch (error) {
//         setIsLoading(false);
//       }
//     };

//     fetchProducts();
//   }, [dispatch]);

//   const handleCreate = async (values) => {
//     const formData = new FormData();
//     if (selectedRecord) {
//       formData.append('id', selectedRecord.id);
//       await dispatch(updateBank({ ...selectedRecord, ...values }));
//       await dispatch(getBank())
//     } else {
//       await dispatch(addBank(values));
//       await dispatch(getBank())
//     }
//     setIsModalVisible(false);
//   };

//   const handleDelete = async (id) => {
//     await dispatch(deleteBank(id));
//     await dispatch(getBank());
//   };

//   console.log("bank :", Bank);

//   const handleChangeStatus = async (id, currentStatus) => {
//     const newStatus = currentStatus === 1 ? 0 : 1; // Toggle status
//     const updatedData = { id: id, status: newStatus }; // Create an object for update
//     await dispatch(updateBank(updatedData));
//     await dispatch(getBank());
//   };

//   const renderCell = (text) => (text ? text : 'N/A');
//   let columns = [
//     {
//       title: "Logo",
//       dataIndex: "logo",
//       key: "logo",
//       sorter: stringSorter("logo"),
//       sortDirections: ["ascend", "descend"],
//       render: (logo) => (
//         <>
//         {console.log("image path :", logo)}

//         <img src={logo} alt="Image" style={{ maxWidth: "100px", maxHeight: "100px" }} />
//         </>
//       ),
//     },
//     {
//       title: "Name",
//       dataIndex: "name",
//       key: "name",
//       sorter: stringSorter("name"),
//       sortDirections: ["ascend", "descend"],
//     },
//     {
//       title: "createdu",
//       dataIndex: "createdu",
//       key: "createdu",
//       sorter: stringSorter("createdu"),
//       sortDirections: ["ascend", "descend"],
//     },
//     {
//       title: "Created At",
//       dataIndex: "createdAt",
//       key: "createdAt",
//       render: (date) => moment(date).isValid() ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "",
//       sorter: (a, b) => moment(a.createdAt).isValid() && moment(b.createdAt).isValid()
//         ? moment(a.createdAt).unix() - moment(b.createdAt).unix()
//         : 0,
//       sortDirections: ["ascend", "descend"],
//     },
//     {
//       title: "Created By",
//       dataIndex: "createdByName",
//       key: "createdByName",
//       sorter: stringSorter("createdByName"),
//       sortDirections: ["ascend", "descend"],
//       render: renderCell,
//     },
//     {
//       title: "Updated At",
//       dataIndex: "updatedAt",
//       key: "updatedAt",
//       render: (date) => moment(date).isValid() ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "",
//       sorter: (a, b) => moment(a.updatedAt).isValid() && moment(b.updatedAt).isValid()
//         ? moment(a.updatedAt).unix() - moment(b.updatedAt).unix()
//         : 0,
//       sortDirections: ["ascend", "descend"],
//     },
//     {
//       title: "Updated By",
//       dataIndex: "updatedByName",
//       key: "updatedByName",
//       sorter: stringSorter("updatedByName"),
//       sortDirections: ["ascend", "descend"],
//     },
//     {
//       title: "Status",
//       dataIndex: "status",
//       key: "status",
//       render: (text, record) => (
//         <Switch
//           checked={text === 1}
//           onChange={() => handleChangeStatus(record.id, text)}
//         />
//       ),
//     },
//     {
//       title: "Action",
//       key: "action",
//       render: (_, record) => (
//         <Space size="middle">
//           <Button
//             type="link"
//             onClick={() => {
//               setSelectedRecord(record);
//               setIsModalVisible(true);
//             }}
//           >
//             <EditOutlined />
//           </Button>
//           {/* <Popconfirm
//             title="Are you sure you want to delete this record?"
//             onConfirm={() => handleDelete(record.id)}
//           >
//             <Button type="link" danger>
//               Delete
//             </Button>
//           </Popconfirm> */}
//         </Space>
//       ),
//     },
//   ];
//   columns = enhanceColumnsWithFilters(columns);

//   return (
//     <div className="page-content">
//       <Breadcrumb style={{ marginBottom: "16px" }}>
//         <Breadcrumb.Item href="/">
//           <HomeOutlined />
//         </Breadcrumb.Item>
//         <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
//         <Breadcrumb.Item>Bank</Breadcrumb.Item>
//       </Breadcrumb>

//       <Card>
//         <Space direction="vertical" size="middle" style={{ width: "100%" }}>
//           <Row justify="space-between" align="middle">
//             <Col>
//               <Title level={2} style={{ margin: 0 }}>
//                 Manage Bank
//               </Title>
//             </Col>
//             <Col>
//               <Button
//                 type="primary"
//                 icon={<PlusOutlined />}
//                 onClick={() => {
//                   setSelectedRecord(null);
//                   setIsModalVisible(true);
//                 }}
//               >
//                 Add Bank
//               </Button>
//             </Col>
//           </Row>
//           {isLoading ? (
//             <div className="d-flex justify-content-center">
//               <Spinner animation="border" variant="primary" />
//             </div>
//           ) : (
//             <DataTable
//               dataSource={Bank.map((item) => ({
//                 ...item,
//                 key: item.id,
//                 status: item.status ? 1 : 0
//               }))}
//               columns={columns}
//             />
//           )}
//         </Space>
//       </Card>
//       <BankForm
//         visible={isModalVisible}
//         onCreate={handleCreate}
//         onCancel={() => setIsModalVisible(false)}
//         record={selectedRecord}
//         // form={form}
//       />
//     </div>
//   );
// };

// export default Bank;
